// extracted by mini-css-extract-plugin
module.exports = {"photosContainer":"grid_photo_popup_photosContainer__z4wtA","baseMediaHeight":"grid_photo_popup_baseMediaHeight__G9cVw","lgMediaHeight":"grid_photo_popup_lgMediaHeight__u3wMe"};